import React, { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import AdminBillRow from './adminBillRow.js';
import { Link } from 'react-router-dom';
import { getBills } from './billsActions';
import { connect } from 'react-redux';
import Loader from '../../components/loader';
import ErrorMessage from '../../components/errorMessage';
import Helmet from 'react-helmet';

const AdminBills = ({ paid, getBills, bills, error, loading }) => {
  useEffect(() => {
    const params = paid ? { onlyPaid: true } : { onlyUnpaid: true };

    if (paid && (!bills || !bills.some((bill) => bill.status === 'PAID'))) {
      getBills(params);
    } else if (!paid && (!bills || !bills.some((bill) => bill.status !== 'PAID'))) {
      getBills(params);
    }
  }, [paid]);

  const { formatMessage } = useIntl();

  return (
    <div>
      <Helmet>
        <title>{formatMessage({ id: paid ? 'admin.bills.paid.title' : 'admin.bills.title' })}</title>
      </Helmet>
      <h3>
        <FormattedMessage id={paid ? 'admin.bills.paid.title' : 'admin.bills.title'} />
      </h3>

      <Loader show={loading} />
      <ErrorMessage error={error} />

      <div className="m-b-2">
        <Link className="btn btn-default m-r-1" to={paid ? `/admin/bills` : `/admin/bills/paid`}>
          <FormattedMessage id={paid ? 'admin.bills.cta.unpaid' : 'admin.bills.cta.paid'} />
        </Link>
        <Link className="btn btn-default m-r-1" to={`/admin/bills/grouped`}>
          <FormattedMessage id={'admin.bills.cta.unpaid.grouped'} />
        </Link>
      </div>

      <table className="table table-striped admin__table m-b-6">
        <thead>
          <tr>
            <th scope="col">Bill id</th>
            <th scope="col">To</th>
            <th scope="col">From</th>
            <th scope="col">Amount</th>
            <th scope="col">Status</th>
            <th scope="col">Deadline</th>
            <th scope="col">Date created</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          {bills ? bills.map((bill, index) => <AdminBillRow showDeadline={true} bill={bill} key={index} />) : ''}
        </tbody>
      </table>
    </div>
  );
};

AdminBills.propTypes = {
  setLoading: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
  paid: PropTypes.bool,
};

AdminBills.defaultProps = {
  paid: false,
};

function mapStateToProps(state) {
  return {
    bills: state.bills.bills,
    loading: state.bills.loading,
    error: state.bills.error,
  };
}

const mapDispatchToProps = {
  getBills,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminBills);
